export const TYPES = {

    APP: {
        SET_ERROR: '[app] SET_ERROR',
        RESET_ERROR: '[app] RESET_ERROR',
        SET_PAGE_REF: '[app] SET_PAGE_REF',
        RESET_PAGE_REF: '[app] RESET_PAGE_REF',
        RESET: '[app] RESET',
        SET_GONOGO: '[app] SET_GONOGO',
        SET_LOADING: '[app] SET_LOADING'
    },

    AUTH: {
        LOGIN: '[auth] LOGIN',
        LOGOUT: '[auth] LOGOUT',
        SET_EMAIL: '[auth] SET_EMAIL',
        SET_ISAUTHENTICATED: '[auth] SET_ISAUTHENTICATED',
        RESET: '[auth] RESET'
    },

    QR: {
        SET_QR: '[qr] SET_QR',
        RESET_TRANSACTION_QR: '[qr] RESET_TRANSACTION_QR',
    },

    TRANSACTION: {

        SET_ENTITY: '[transaction] SET_ENTITY',
        ACTIVATED: '[transaction] ACTIVATED',
        LIST: '[transaction] LIST',
        RESET: '[transaction] RESET',
        UPDATE: '[transaction] UPDATE',
        METADATA: '[transaction] METADATA'
    },

    BENEFIT: {

        ACTIVATED: '[benefit] ACTIVATED',
        LIST: '[benefit] LIST',
        RESET_BENEFIT: '[benefit] RESET_BENEFIT'
    }
};